<!--  -->
<template>
  <div class="DialogEdit">
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible" :width="isBig?'900px':'600px'">
      <slot name="main"></slot>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideDialog()">取 消</el-button>
        <el-button type="primary" @click="confirmF()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  props: {
    title: "",
    isBig:false,
  },
  components: {},

  computed: {},

  mounted() {},

  methods: {
      showDialog(){
          this.dialogVisible = true;
      },
      hideDialog(){
        this.dialogVisible = false;
        this.$emit('cancel')
      },
      confirmF(){
        this.$emit('confirm',this.hideDialog)
      }
  },
};
</script>
<style scoped lang="scss">
/deep/ .el-dialog {
  .el-dialog__header {
    padding: 15px 20px;
    text-align: left;
    background: #f5f5f5;
    .el-dialog__title {
      font-size: 14px;
    }
  }
  .el-dialog__body {
    padding: 50px 20px;
    max-height: 550px;
    overflow-y: auto;
  }
  .el-dialog__footer{
    border: 1px solid #ddd;
    height: 60px;
    .el-button{
      width: 80px;
      height: 30px;
      padding: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DialogEdit.vue